module.exports = __webpack_public_path__ + "static/img/37_pro.a5f12a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/37_pro.jpg
// module id = TCoT
// module chunks = 0